import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatDatePicker = createCustomElementWrapper('kat-date-picker', 'KatDatePicker', {
    'constraintEmphasis': 'constraint-emphasis',
    'constraintLabel': 'constraint-label',
    'katAriaLabel': 'kat-aria-label',
    'showClear': 'show-clear',
    'stateEmphasis': 'state-emphasis',
    'stateLabel': 'state-label',
    'tooltipPosition': 'tooltip-position',
    'tooltipText': 'tooltip-text',
    'tooltipTriggerIcon': 'tooltip-trigger-icon',
}, {
    'onChange': 'change',
    'onInvalid': 'invalid',
});
